import { MaskedFieldManagerBase } from '@cof/fs-masked-field-manager-base';
import { isNumberKey } from './phone-number-field-utilities.js';
import { PhoneNumberFieldInputEvent } from './PhoneNumberFieldEvent.js';
export class PhoneNumberFieldManager extends MaskedFieldManagerBase {
    /**
     * Whether or not the number is international.
     */
    /* c8 ignore next 3 - NOTE: C8 not properly covering this method */
    get isInternationalNumber() {
        return this._input != null && this._input.value.charAt(0) === this._internationalNumberSignifier;
    }
    /* c8 ignore next 6 - NOTE: C8 not properly covering constructor */
    constructor(field, config = {}) {
        // Pull the input from the field.
        const input = field.querySelector('input');
        super(input, config);
        /**
         * The signifying character used to determine if a phone number is an international phone number.
         */
        this._internationalNumberSignifier = '+';
        /**
         * The visual separator used to aid in readability by splitting the number into meaningful components.
         * See: https://www.rfc-editor.org/rfc/rfc3966#section-5.1.1
         */
        this._separator = '-';
        /* c8 ignore next 12 - NOTE: C8 not properly covering method */
        this._handleInsertFromPaste = () => {
            const { selectionStart, selectionEnd, value } = this._input;
            // Allow `-` characters in pasted value.
            const dissalowedCharacterRegexString = `[^\\d${this._separator}]`;
            const disallowedCharacterRegex = new RegExp(dissalowedCharacterRegexString, 'gim');
            const cleanedValue = value.replace(disallowedCharacterRegex, '');
            const cursorPositionOffset = value.length - cleanedValue.length;
            this._input.value = cleanedValue;
            this._input.selectionStart = selectionStart - cursorPositionOffset;
            this._input.selectionEnd = selectionEnd - cursorPositionOffset;
        };
    }
    /* c8 ignore next 19 - NOTE: C8 not properly covering method */
    _maskValue(unmaskedValue) {
        // Do not attempt to format international numbers.
        if (this.isInternationalNumber) {
            return unmaskedValue;
        }
        unmaskedValue = this._unmaskValue(unmaskedValue);
        // Only format numbers that meet our formatting criteria.
        if (unmaskedValue.length === 10) {
            return unmaskedValue.replace(/(\d{3})(\d{3})(\d{4})/gim, '$1-$2-$3');
        }
        if (unmaskedValue.length === 11) {
            return unmaskedValue.replace(/(\d)(\d{3})(\d{3})(\d{4})/gim, '$1-$2-$3-$4');
        }
        return unmaskedValue;
    }
    /* c8 ignore next 7 - NOTE: C8 not properly covering method */
    _unmaskValue(maskedvalue) {
        if (this.isInternationalNumber) {
            return maskedvalue;
        }
        return maskedvalue.replace(/\D/gim, '');
    }
    /* c8 ignore next 21 - NOTE: C8 not properly covering method */
    _getValidityState() {
        const customValidity = this._getInitialValidityStateForInput();
        if (!this.isInternationalNumber && this.unmaskedValue.length < 10) {
            customValidity.tooShort = true;
        }
        if (!this.isInternationalNumber && this.unmaskedValue.length > 11) {
            customValidity.tooLong = true;
        }
        if (this._input.hasAttribute('pattern')) {
            const pattern = this._input.getAttribute('pattern');
            const patternRegex = new RegExp(pattern);
            customValidity.patternMismatch = !patternRegex.test(this.maskedValue);
        }
        customValidity.valid = Object.values(customValidity).every((isInvalid) => isInvalid === false);
        return customValidity;
    }
    /* c8 ignore next 5 - NOTE: C8 not properly covering method */
    _dispatchMaskedFieldInputEvent() {
        this.dispatchEvent(new PhoneNumberFieldInputEvent(this._getValidityState(), this.maskedValue, this.unmaskedValue, this._input));
    }
    /* c8 ignore next 8 - NOTE: C8 not properly covering method */
    _isKeydownAllowed(event) {
        return (super._isKeydownAllowed(event) ||
            (this._config.allowInternationalNumber && event.key === this._internationalNumberSignifier) ||
            event.key === this._separator ||
            isNumberKey(event));
    }
}
//# sourceMappingURL=PhoneNumberFieldManager.js.map